export function setCookie(name, value, expire, domain = '') {
    let expires = 0
    if(expire) {
        let date = new Date();
        let time = date.getTime();
        date = new Date(time+(1000 * expire));
        expires = 'expires='+date+';'
    }else{
        expires = '';
    }
    document.cookie = name+"="+value+';'+expires+'path=/;domain='+domain;
}

export function getCookie(cookieName) {
    var name = cookieName + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function deleteCookie(name, domain = '') {
    document.cookie = name+"=''; expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain="+domain;
}


// WEBPACK FOOTER //
// ./src/libraries/Cookies.js